import React from "react";

export default function Logo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={164}
      height={32}
      fill="none"
      className="text-foundations-boldest"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M160.229 3.2H38.593v25.6h121.636V3.2ZM35.418 0v32h127.986V0H35.418Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M115.876 10.626v4.144h-5.342v-4.144h-2.671v10.748h2.671v-4.087h5.342v4.087h2.685V10.626h-2.685ZM119.411 21.374h2.94l1.08-2.093h4.987l1.065 2.093h2.941l-5.114-10.748h-2.771l-5.128 10.748Zm4.873-4.483 1.633-3.253 1.648 3.253h-3.281ZM138.273 21.6c3.083 0 4.859-1.075 4.859-3.238 0-2.433-2.401-2.885-3.467-3.182-1.278-.382-1.733-.523-2.301-.679-.981-.255-1.435-.537-1.421-1.032 0-.721 1.151-.905 1.819-.905.966 0 2.045.297 2.187 1.428h2.913c-.114-2.164-1.819-3.592-4.944-3.592-2.373 0-4.902.877-4.902 3.21 0 1.542 1.165 2.334 2.7 2.9.881.338 1.776.537 2.614.777.966.283 2.017.608 2.017 1.188s-.739.933-1.989.933c-1.563 0-2.6-.452-2.983-1.513h-2.884c.227 2.248 2.046 3.705 5.782 3.705ZM152.627 10.626v4.144h-5.341v-4.144h-2.671v10.748h2.671v-4.087h5.341v4.087h2.685V10.626h-2.685ZM43.467 21.374h2.664v-5.586l2.72 5.586h2.564l2.72-5.586v5.586H56.8V10.626h-2.947l-3.712 7.75-3.74-7.75h-2.933v10.748ZM64.75 21.6c4.193 0 6.545-2.574 6.545-5.6 0-3.04-2.352-5.6-6.546-5.6-4.18 0-6.545 2.56-6.545 5.6 0 3.026 2.366 5.6 6.545 5.6Zm0-2.29c-2.423 0-3.67-1.797-3.67-3.31 0-1.513 1.247-3.31 3.67-3.31 2.422 0 3.669 1.797 3.669 3.31 0 1.513-1.247 3.31-3.67 3.31ZM72.73 21.374h2.663v-6.166l5.37 6.166h2.635V10.626H80.72v6.336l-5.426-6.336H72.73v10.748ZM88.01 18.73v-1.57h6.022v-2.39h-6.021v-1.5h6.588v-2.644h-9.223v10.748h9.506v-2.645h-6.871ZM99.79 21.374h2.692v-3.762l4.477-6.986h-2.975l-2.848 4.639-2.847-4.639h-2.975l4.477 6.986v3.762Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M32.198 0H0v17.5h11.193l.832-2.76h-2.97l.456-2.04h3.009l1.266-4.3h2.593l-1.266 4.3h3.88l1.266-4.3h2.613l-1.267 4.3h10.593v2.04H21.11l-.831 2.76h3.064l-.471 2.04h-3.088l-1.188 4.06h-2.613l1.208-4.06h-3.86l-1.227 4.06H9.51l1.207-4.06H0V32h32.198V0Zm-17.56 14.74-.812 2.76h3.86l.811-2.76h-3.86Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
